import React from 'react';
import { connect } from 'react-redux';
import { goToErrorsView } from 'actions/errorViewNavigation';

const mapDispatchToProps = {
    goToErrorsView,
};

export const withErrorViewNavigation = WrappedComponent => {
    const BaseWithErrorViewNavigation = props => <WrappedComponent {...props} />;

    BaseWithErrorViewNavigation.displayName = `withErrorViewNavigation(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    return connect(null, mapDispatchToProps)(BaseWithErrorViewNavigation);
};
